import { format, parse } from 'date-fns';

const APPLICATION_DATE_FORMAT = 'dd/MM/yyyy';

const BACKEND_DATE_FORMAT = 'dd-MM-yyyy';

export const formatDateForBackend = (date?: string): string | undefined =>
    date?.length ? format(parse(date, APPLICATION_DATE_FORMAT, new Date()), BACKEND_DATE_FORMAT) : undefined;

export const formatDateFromBackend = (date?: string): string | undefined =>
    date?.length ? format(parse(date, BACKEND_DATE_FORMAT, new Date()), APPLICATION_DATE_FORMAT) : undefined;
